import React from 'react';
import { useTranslation } from 'react-i18next';
import './PackagePriceCard.css';
import GradientButton from '../ui/GradientButton/GradientButton';
import SoldOutButton from '../ui/SoldOutButton/SoldOutButton'; // ✅ Import your SoldOutButton
import LeftElement from '../../assets/elements/left.png';
import RightElement from '../../assets/elements/right.png';

interface PackagePriceCardProps {
  title: string;
  description: string;
  price: number | string;
  buttonText: string;
  subtext?: string;
  onButtonClick: () => void;
  isSoldOut?: boolean;
}

const PackagePriceCard: React.FC<PackagePriceCardProps> = ({
  title,
  description,
  price,
  buttonText,
  subtext,
  onButtonClick,
  isSoldOut = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="package-price-card-wrapper">
      {/* Left SVG Element */}
      <img src={LeftElement} alt="Decorative Left Element" className="svg-element left" />

      {/* Main Card */}
      <div className="package-price-card">
        <h2 className="package-title">{title}</h2>
        <p className="package-description">{description}</p>
        <div className="package-price">
          <span className="price-amount">{price}</span>
          <span className="price-subtext">{t('one_time_payment')}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {isSoldOut ? (
            <SoldOutButton>{t('sold_out')}</SoldOutButton> // ✅ Use SoldOutButton
          ) : (
            <GradientButton onClick={onButtonClick}>
              {buttonText}
            </GradientButton>
          )}
        </div>
        {subtext && <p className="package-subtext">{subtext}</p>}
      </div>

      {/* Right SVG Element */}
      <img src={RightElement} alt="Decorative Right Element" className="svg-element right" />
    </div>
  );
};

export default PackagePriceCard;
